import { FC, useState } from 'react';
import SearchIcon from '../../assets/search.png'; // Make sure this is a React component or adjust accordingly
import { SearchProps } from './search.type';
import './search.css';
import { getIdAttributes } from '../../utils/helper';

export const idPrefix: string = 'custom-search';

const Search: FC<SearchProps> = (props) => {
  const prefix: string = idPrefix;
  const [searchStr, setSearchStr] = useState<string>(props.query);

  const handleOnChange = (value: string): void => {
    setSearchStr(value);
    props.onChange(value);
  };

  const handleClear = (): void => {
    setSearchStr('');
    props.onChange('');
  };

  return (
    <div
      className={`search-contain ${
        props.iconRight ? 'flex-row-reverse pr-[10px]' : ''
      } ${props.containerClass ?? ''}`}
      {...getIdAttributes(prefix, 'container')}
    >
      <img
        src={SearchIcon}
        alt="Search Icon"
        height={props.iconSize}
        width={props.iconSize}
        {...getIdAttributes(prefix, 'icon')}
      />
      <div className="relative flex-1">
        <input
          className={`search-input-container ${props.inputClass ?? ''}`}
          type="text"
          placeholder={props.placeholder ?? ''}
          value={searchStr}
          onChange={(e) => handleOnChange(e.target.value)}
          {...getIdAttributes(prefix, 'input')}
        />
        {searchStr && (
          <button
            onClick={handleClear}
            className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 cursor-pointer bg-transparent border-none text-sm font-medium"
            {...getIdAttributes(prefix, 'clear')}
          >
            x
          </button>
        )}
      </div>
    </div>
  );
};

export default Search;
